import './all-external-dependencies'
import './lazy-recorder'
import posthog from './module.no-external.es'
export * from './module.no-external.es'
export default posthog
